import { h } from "preact"
import { pure } from "util/pure-component"
import { KeypadDigits } from "./keypad-digits"
import { KeypadOps } from "./keypad-ops"
import "./index.css"
import { KeypadAdvanced } from "./keypad-advanced"

export const Keypad = pure<KeypadProps>(function _Keypad({ onPress }) {
  return (
    <div
      className="keypad d-grid overflow-visible mx-auto py-4"
      style={{
        justifyItems: "stretch",
        alignItems: "stretch"
      }}
    >
      <KeypadDigits onPress={onPress} />
      <KeypadOps onPress={onPress} />
      <KeypadAdvanced onPress={onPress} />
    </div>
  )
})

export interface KeypadProps {
  onPress(symbol: string): void
}
